export const GROUP_BY_FIELDS = ['client', 'sku', 'variant', 'size', 'status'];

export const GROUP_BY_ALIASES = {
  cliente: 'client',
  client: 'client',
  sku: 'sku',
  variante: 'variant',
  variant: 'variant',
  color: 'variant',
  talle: 'size',
  talla: 'size',
  size: 'size',
  estado: 'status',
  status: 'status'
};

export const QUICK_VIEWS = [
  { id: 'client', label: 'Por cliente', fields: ['client'] },
  { id: 'sku', label: 'Por SKU', fields: ['sku'] },
  { id: 'variant', label: 'Por color', fields: ['variant'] },
  { id: 'size', label: 'Por talle', fields: ['size'] },
  { id: 'status', label: 'Por estado', fields: ['status'] },
  { id: 'sku_variant', label: 'SKU -> color', fields: ['sku', 'variant'] },
  { id: 'client_status', label: 'Cliente -> estado', fields: ['client', 'status'] },
  { id: 'status_sku', label: 'Estado -> SKU', fields: ['status', 'sku'] },
  { id: 'variant_size', label: 'Color -> talle', fields: ['variant', 'size'] }
];

export const GROUP_LABELS = {
  client: 'Cliente',
  sku: 'SKU',
  variant: 'Color',
  size: 'Talle',
  status: 'Estado'
};

const splitGroupBy = (input) => {
  if (!input) return [];
  if (Array.isArray(input)) return input;
  return String(input)
    .split(/[,+;]+/g)
    .map((part) => part.trim())
    .filter(Boolean);
};

export const normalizeGroupBy = (input) => {
  const tokens = splitGroupBy(input);
  const normalized = [];

  tokens.forEach((token) => {
    const key = GROUP_BY_ALIASES[String(token).toLowerCase()];
    if (!key) return;
    if (!normalized.includes(key)) normalized.push(key);
  });

  if (!normalized.length) return ['client'];
  return normalized;
};

export const stringifyGroupBy = (input) => normalizeGroupBy(input).join(',');

export const areGroupFieldsEqual = (left = [], right = []) => {
  if (left.length !== right.length) return false;
  return left.every((field, idx) => field === right[idx]);
};

export const moveGroupField = (fields, from, to) => {
  const list = normalizeGroupBy(fields);
  if (from < 0 || to < 0 || from >= list.length || to >= list.length) return list;
  const next = [...list];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
};
